/* tslint:disable */

declare var Object: any;
export interface ERPinventoryAdjustmentInterface {
  "id"?: number;
}

export class ERPinventoryAdjustment implements ERPinventoryAdjustmentInterface {
  "id": number;
  constructor(data?: ERPinventoryAdjustmentInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPinventoryAdjustment`.
   */
  public static getModelName() {
    return "ERPinventoryAdjustment";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPinventoryAdjustment for dynamic purposes.
  **/
  public static factory(data: ERPinventoryAdjustmentInterface): ERPinventoryAdjustment{
    return new ERPinventoryAdjustment(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPinventoryAdjustment',
      plural: 'ERPinventoryAdjustments',
      path: 'ERPinventoryAdjustments',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPinventoryAdjustment.ts